<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import { mountedBase, BaseSetup, onDelete } from "@/DataLoaderStatic";
import { goBack } from "@/NavigationHelper";
import AUApi from "@/api";

let deleteVisible = ref<boolean>(false);
const props = defineProps<{
  bewegungsdaten?: boolean;
  newData?: boolean;
  siteData?: any;
}>();
const emit = defineEmits(["back", "save"]);
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_DVH_Anlage_Hotline",
  bewegungsdaten: props.bewegungsdaten,
  emitBack: () => emit("back"),
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data && uiData.data.length > 0) {
    if (uiData.data && uiData.data[0].aic_Bew_pool) {
      deleteVisible.value = true;
    }
  }
  uiData.showLoading = false;
  uiData.initialized = true;
});

async function bewDelete() {
  if (uiData.data && uiData.data[0].aic_Bew_pool) {
    await onDelete(uiData, pageParams, uiData.data[0].aic_Bew_pool, "");
    emit("back");
  }
}
</script>
<template>
  <v-sheet class="pa-0">
    <v-card :loading="uiData.showLoading" v-if="uiData.initialized" min-width="900px">
      <v-card-title style="background-color: green; color: white">Hotline</v-card-title>
      <v-card-text class="pt-4">
        <v-row class="px-5">
          <v-col cols="12" sm="6">
            <EditDatePicker kennung="ERFASST_AM"></EditDatePicker>
          </v-col>
          <v-col cols="12" sm="6">
            <EditComboBox
              kennung="VERFASSER_BEWST"
              :queryZeitbereich="uiData.zeitbereich"
            />
          </v-col>
        </v-row>

        <v-row class="px-5">
          <v-col cols="12" sm="6">
            <EditComboBox
              kennung="ARTIKELGRUPPE"
              :queryZeitbereich="uiData.zeitbereich"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <EditComboBox kennung="EMPFANGSART" :queryZeitbereich="uiData.zeitbereich" />
          </v-col>
        </v-row>
        <div class="outline_dark">
          <p class="dvhHotline">Problembeschreibung</p>
          <v-row class="px-5">
            <v-col cols="12" sm="4">
              <EditZahl kennung="VERR_EINH" />
            </v-col>
            <v-col cols="12" sm="8">
              <EditTextField kennung="DV_SUCHBEGRIFF" />
            </v-col>
          </v-row>

          <div class="outline_lightgrey">
            <p class="dvhHotline">Anliegen</p>
            <EditTextArea class="px-2" kennung="HOTLINEPROBLEM" />
          </div>

          <EditFileChoicer kennung="SPEICHERPFAD" />
          <v-row class="px-5">
            <v-col cols="12" sm="6">
              <EditDatePicker kennung="ERLEDIGUNGSDATUM"></EditDatePicker>
            </v-col>
            <v-col cols="12" sm="6">
              <EditComboBox kennung="VERSANDART" :queryZeitbereich="uiData.zeitbereich" />
            </v-col>
          </v-row>

          <v-row class="px-5">
            <v-col cols="12" sm="6">
              <EditCheckBox kennung="VERRECHNEN" />
            </v-col>
            <v-col cols="12" sm="6">
              <EditCheckBox kennung="WA_NICHT_VERRECHNEN" />
            </v-col>
          </v-row>

          <v-row class="px-5">
            <v-col cols="12" sm="6">
              <EditCheckBox kennung="PROBLEM GELOEST" />
            </v-col>
            <v-col cols="12" sm="6">
              <EditCheckBox kennung="DVH_INTERNER_VERMERK" />
            </v-col>
          </v-row>

          <div class="outline_lightgrey">
            <p class="dvhHotline">Lösung</p>
            <EditTextArea class="px-2" kennung="LÖSUNG" />
          </div>
        </div>

        <divider></divider>

        <EditFileChoicer kennung="ABLAGE" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CommonBaseButtons
          :deleteVisible="deleteVisible"
          :createVisible="false"
          :refreshVisible="false"
          :backVisible="false"
          @delete="bewDelete"
          @back="goBack()"
          :saveVisible="true"
        ></CommonBaseButtons>
      </v-card-actions>
    </v-card>
  </v-sheet>
</template>
<style scoped>
.dvhCol {
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.dvhHotline {
  font-size: 1.5em;
  font-weight: bold;
}

.outline_lightgrey {
  border-radius: 10px;
  padding: 10px;
  margin: 5px;
  background-color: white;
}

.outline_dark {
  border-radius: 10px;
  padding: 10px;
  margin: 5px;
  background-color: rgba(240, 248, 255, 0.336);
}

.empty {
  height: 2em;
}

.fixedFont {
  font-size: 2em !important;
}
</style>
